module.exports = __webpack_public_path__ + "static/img/announcement_bg.646bf1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/announcement_bg.png
// module id = zznp
// module chunks = 10